import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { BootScreen } from './components/BootScreen';
import { Desktop } from './components/Desktop';
import { LockScreen } from './components/LockScreen';
import { WindowsProvider } from './context/WindowsContext';
export function App() {
  const [isBooting, setIsBooting] = useState(true);
  const [isLocked, setIsLocked] = useState(true);
  return <WindowsProvider data-id="element-0" data-mp="2rlozuqfd2dda">
      <AnimatePresence mode="wait" data-id="element-1" data-mp="2rl6t2zv2ogr4">
        {isBooting && <BootScreen key="boot" onComplete={() => setIsBooting(false)} data-id="element-2" data-mp="2mmlwdaf14f7f" />}
        {!isBooting && isLocked && <LockScreen key="lock" onUnlock={() => setIsLocked(false)} data-id="element-3" data-mp="31c9uy3vtszrg" />}
      </AnimatePresence>
      {!isBooting && !isLocked && <Desktop data-id="element-4" data-mp="2wi5nljineppu" />}
    </WindowsProvider>;
}